const RELOAD_KEY = 'crm:new-version-reload'
const RELOAD_GAP_MS = 60_000
const STALE_FILE =
  /dynamically imported module|importing a module script failed|error loading dynamically|unable to preload|mime type/i

const messageOf = (error: unknown) => (error instanceof Error ? error.message : String(error))

/** A release replaces the page files, so an open tab can ask for one that no longer exists. */
export const isStaleFile = (error: unknown) => STALE_FILE.test(messageOf(error))

/** Reloads onto the new release once; a second failure in a row is shown to the person instead. */
export const reloadForNewVersion = () => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0)
  if (Date.now() - last < RELOAD_GAP_MS) return false
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  window.location.reload()
  return true
}

const reported = new Set<string>()

/** Sends a browser crash to the server log, once per message, so it can be diagnosed. */
export const reportClientError = (error: unknown) => {
  const message = messageOf(error).slice(0, 2000)
  if (reported.has(message)) return
  reported.add(message)
  void fetch('/api/client-errors', {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      message,
      stack: error instanceof Error ? (error.stack ?? '').slice(0, 4000) : '',
      path: window.location.pathname.slice(0, 500),
    }),
  }).catch(() => {})
}

export const watchClientErrors = () => {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadForNewVersion()) event.preventDefault()
  })
  window.addEventListener('error', (event) => reportClientError(event.error ?? event.message))
  window.addEventListener('unhandledrejection', (event) => reportClientError(event.reason))
}
